module.exports = {
      id: "Cart_Added-usage",
      viewBox: "0 0 63 55",
      url: __webpack_public_path__ + "../../../../skin/frontend/api/assets/mcp/svg/product/sprite.svg#Cart_Added-usage",
      toString: function () {
        return this.url;
      }
    }